// Constantes des permissions par module

export const PERMISSIONS = {
  // Dashboard
  DASHBOARD: {
    READ: 'dashboard:read',
    VIEW: 'dashboard:view',
    CREATE: 'dashboard:create',
    UPDATE: 'dashboard:update',
    DELETE: 'dashboard:delete',
    CONFIGURE: 'dashboard:configure',
    CUSTOMIZE: 'dashboard:customize'
  },

  // Employee
  EMPLOYEE: {
    READ: 'employee:read',
    VIEW: 'employee:view',
    CREATE: 'employee:create',
    UPDATE: 'employee:update',
    DELETE: 'employee:delete',
    MANAGE_DOCUMENTS: 'employee:manage_documents',
    MANAGE_CONTRACTS: 'employee:manage_contracts',
    EXPORT: 'employee:export'
  },

  // Payroll
  PAYROLL: {
    READ: 'payroll:read',
    VIEW: 'payroll:view',
    CREATE: 'payroll:create',
    UPDATE: 'payroll:update',
    DELETE: 'payroll:delete',
    PROCESS: 'payroll:process',
    MANAGE_SALARIES: 'payroll:manage_salaries',
    MANAGE_BONUSES: 'payroll:manage_bonuses',
    EXPORT: 'payroll:export'
  },

  // Absence
  ABSENCE: {
    READ: 'absence:read',
    VIEW: 'absence:view',
    CREATE: 'absence:create',
    UPDATE: 'absence:update',
    DELETE: 'absence:delete',
    SUBMIT: 'absence:submit',
    APPROVE: 'absence:approve',
    MANAGE_TYPES: 'absence:manage_types',
    EXPORT: 'absence:export'
  },

  // Attendance/Presence
  ATTENDANCE: {
    READ: 'attendance:read',
    VIEW: 'attendance:view',
    CREATE: 'attendance:create',
    UPDATE: 'attendance:update',
    DELETE: 'attendance:delete',
    PROCESS: 'attendance:process',
    MANAGE_SCHEDULES: 'attendance:manage_schedules',
    EXPORT: 'attendance:export'
  },

  // Presence (alias pour attendance)
  PRESENCE: {
    READ: 'presence:read',
    VIEW: 'presence:view',
    CREATE: 'presence:create',
    UPDATE: 'presence:update',
    DELETE: 'presence:delete',
    PROCESS: 'presence:process',
    MANAGE_SCHEDULES: 'presence:manage_schedules',
    EXPORT: 'presence:export'
  },

  // Remuneration
  REMUNERATION: {
    READ: 'remuneration:read',
    VIEW: 'remuneration:view',
    CREATE: 'remuneration:create',
    UPDATE: 'remuneration:update',
    DELETE: 'remuneration:delete',
    MANAGE_SALARIES: 'remuneration:manage_salaries',
    EXPORT: 'remuneration:export'
  },

  // Expense/Notes de frais
  EXPENSE: {
    READ: 'expense:read',
    VIEW: 'expense:view',
    CREATE: 'expense:create',
    UPDATE: 'expense:update',
    DELETE: 'expense:delete',
    SUBMIT: 'expense:submit',
    APPROVE: 'expense:approve',
    EXPORT: 'expense:export'
  },

  // Union/Syndicats
  UNION: {
    READ: 'union:read',
    VIEW: 'union:view',
    CREATE: 'union:create',
    UPDATE: 'union:update',
    DELETE: 'union:delete',
    MANAGE_MEMBERS: 'union:manage_members',
    MANAGE_EVENTS: 'union:manage_events',
    EXPORT: 'union:export'
  },

  // Equipment/Équipements
  EQUIPMENT: {
    READ: 'equipment:read',
    VIEW: 'equipment:view',
    CREATE: 'equipment:create',
    UPDATE: 'equipment:update',
    DELETE: 'equipment:delete',
    ASSIGN: 'equipment:assign',
    EXPORT: 'equipment:export'
  },

  // Document
  DOCUMENT: {
    READ: 'document:read',
    VIEW: 'document:view',
    CREATE: 'document:create',
    UPDATE: 'document:update',
    DELETE: 'document:delete',
    UPLOAD: 'document:upload',
    DOWNLOAD: 'document:download',
    EXPORT: 'document:export'
  },

  // Document Types
  DOCUMENT_TYPE: {
    READ: 'document_type:read',
    VIEW: 'document_type:view',
    CREATE: 'document_type:create',
    UPDATE: 'document_type:update',
    DELETE: 'document_type:delete',
    EXPORT: 'document_type:export'
  },

  // Document Templates
  DOCUMENT_TEMPLATE: {
    READ: 'document_template:read',
    VIEW: 'document_template:view',
    CREATE: 'document_template:create',
    UPDATE: 'document_template:update',
    DELETE: 'document_template:delete',
    GENERATE: 'document_template:generate',
    PUBLISH: 'document_template:publish',
    ARCHIVE: 'document_template:archive',
    EXPORT: 'document_template:export'
  },

  // User
  USER: {
    READ: 'user:read',
    VIEW: 'user:view',
    CREATE: 'user:create',
    UPDATE: 'user:update',
    DELETE: 'user:delete',
    MANAGE_ROLES: 'user:manage_roles',
    ASSIGN: 'user:assign',
    EXPORT: 'user:export'
  },

  // Client/Organization
  CLIENT: {
    READ: 'client:read',
    VIEW: 'client:view',
    CREATE: 'client:create',
    UPDATE: 'client:update',
    DELETE: 'client:delete',
    MANAGE_USERS: 'client:manage_users',
    EXPORT: 'client:export'
  },

  // Reports
  REPORTS: {
    READ: 'reports:read',
    VIEW: 'reports:view',
    CREATE: 'reports:create',
    UPDATE: 'reports:update',
    DELETE: 'reports:delete',
    CREATE_CUSTOM: 'reports:create_custom',
    EXPORT: 'reports:export'
  },

  // Analytics
  ANALYTICS: {
    READ: 'analytics:read',
    VIEW: 'analytics:view',
    EXPORT: 'analytics:export'
  },

  // System
  SYSTEM: {
    READ: 'system:read',
    VIEW: 'system:view',
    CONFIG: 'system:config',
    ADMIN: 'system:admin',
    BACKUP: 'system:backup',
    LOGS: 'system:logs'
  },

  // Notification
  NOTIFICATION: {
    READ: 'notification:read',
    VIEW: 'notification:view',
    SEND: 'notification:send',
    MANAGE_TEMPLATES: 'notification:manage_templates'
  },

  // File
  FILE: {
    READ: 'file:read',
    VIEW: 'file:view',
    UPLOAD: 'file:upload',
    DOWNLOAD: 'file:download',
    DELETE: 'file:delete',
    MANAGE_STORAGE: 'file:manage_storage'
  },

  // Audit
  AUDIT: {
    READ: 'audit:read',
    VIEW: 'audit:view',
    EXPORT: 'audit:export'
  },

  // Integration
  INTEGRATION: {
    READ: 'integration:read',
    VIEW: 'integration:view',
    UPDATE: 'integration:update',
    MANAGE_KEYS: 'integration:manage_keys'
  },

  // Workflow
  WORKFLOW: {
    READ: 'workflow:read',
    VIEW: 'workflow:view',
    CREATE: 'workflow:create',
    UPDATE: 'workflow:update',
    DELETE: 'workflow:delete',
    EXECUTE: 'workflow:execute'
  },

  // Form
  FORM: {
    READ: 'form:read',
    VIEW: 'form:view',
    CREATE: 'form:create',
    UPDATE: 'form:update',
    DELETE: 'form:delete',
    SUBMIT: 'form:submit'
  },

  // Calendar
  CALENDAR: {
    READ: 'calendar:read',
    VIEW: 'calendar:view',
    UPDATE: 'calendar:update',
    MANAGE_EVENTS: 'calendar:manage_events'
  },

  // Task
  TASK: {
    READ: 'task:read',
    VIEW: 'task:view',
    CREATE: 'task:create',
    UPDATE: 'task:update',
    DELETE: 'task:delete',
    ASSIGN: 'task:assign'
  },

  // Project
  PROJECT: {
    READ: 'project:read',
    VIEW: 'project:view',
    CREATE: 'project:create',
    UPDATE: 'project:update',
    DELETE: 'project:delete',
    MANAGE_MEMBERS: 'project:manage_members'
  },

  // Budget
  BUDGET: {
    READ: 'budget:read',
    VIEW: 'budget:view',
    UPDATE: 'budget:update',
    APPROVE: 'budget:approve',
    EXPORT: 'budget:export'
  },

  // Training
  TRAINING: {
    READ: 'training:read',
    VIEW: 'training:view',
    CREATE: 'training:create',
    UPDATE: 'training:update',
    DELETE: 'training:delete',
    ASSIGN: 'training:assign'
  },

  // Evaluation
  EVALUATION: {
    READ: 'evaluation:read',
    VIEW: 'evaluation:view',
    CREATE: 'evaluation:create',
    UPDATE: 'evaluation:update',
    DELETE: 'evaluation:delete',
    SUBMIT: 'evaluation:submit'
  },

  // Recruitment
  RECRUITMENT: {
    READ: 'recruitment:read',
    VIEW: 'recruitment:view',
    CREATE: 'recruitment:create',
    UPDATE: 'recruitment:update',
    DELETE: 'recruitment:delete',
    MANAGE_CANDIDATES: 'recruitment:manage_candidates'
  },

  // Planning
  PLANNING: {
    READ: 'planning:read',
    VIEW: 'planning:view',
    UPDATE: 'planning:update',
    MANAGE_SHIFTS: 'planning:manage_shifts',
    EXPORT: 'planning:export'
  },

  // Leave/Congés
  LEAVE: {
    READ: 'leave:read',
    VIEW: 'leave:view',
    CREATE: 'leave:create',
    UPDATE: 'leave:update',
    APPROVE: 'leave:approve',
    MANAGE_BALANCES: 'leave:manage_balances'
  },

  // Medical
  MEDICAL: {
    READ: 'medical:read',
    VIEW: 'medical:view',
    UPDATE: 'medical:update',
    MANAGE_VISITS: 'medical:manage_visits',
    EXPORT: 'medical:export'
  },

  // Security
  SECURITY: {
    READ: 'security:read',
    VIEW: 'security:view',
    UPDATE: 'security:update',
    MANAGE_ACCESS: 'security:manage_access',
    MANAGE_KEYS: 'security:manage_keys'
  },

  // Settings/Config
  SETTINGS: {
    READ: 'settings:read',
    VIEW: 'settings:view',
    UPDATE: 'settings:update',
    MANAGE_GLOBAL: 'settings:manage_global',
    MANAGE_LOCAL: 'settings:manage_local'
  },

  // Department
  DEPARTMENT: {
    READ: 'department:read',
    VIEW: 'department:view',
    CREATE: 'department:create',
    UPDATE: 'department:update',
    DELETE: 'department:delete',
    EXPORT: 'department:export'
  },

  // Position/Poste
  POSITION: {
    READ: 'position:read',
    VIEW: 'position:view',
    CREATE: 'position:create',
    UPDATE: 'position:update',
    DELETE: 'position:delete',
    EXPORT: 'position:export'
  },

  // Employment Type
  EMPLOYMENT_TYPE: {
    READ: 'employment_type:read',
    VIEW: 'employment_type:view',
    CREATE: 'employment_type:create',
    UPDATE: 'employment_type:update',
    DELETE: 'employment_type:delete',
    EXPORT: 'employment_type:export'
  },

  // Competence Type
  COMPETENCE_TYPE: {
    READ: 'competence_type:read',
    VIEW: 'competence_type:view',
    CREATE: 'competence_type:create',
    UPDATE: 'competence_type:update',
    DELETE: 'competence_type:delete',
    EXPORT: 'competence_type:export'
  },

  // Departure Reason
  DEPARTURE_REASON: {
    READ: 'departure_reason:read',
    VIEW: 'departure_reason:view',
    CREATE: 'departure_reason:create',
    UPDATE: 'departure_reason:update',
    DELETE: 'departure_reason:delete',
    EXPORT: 'departure_reason:export'
  },

  // Queue
  QUEUE: {
    READ: 'queue:read',
    VIEW: 'queue:view',
    MANAGE: 'queue:manage',
    EXECUTE: 'queue:execute'
  },

  // Upload
  UPLOAD: {
    READ: 'upload:read',
    VIEW: 'upload:view',
    UPLOAD: 'upload:upload',
    DELETE: 'upload:delete',
    MANAGE: 'upload:manage'
  }
} as const

// Rôles disponibles
export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  EMPLOYEE: 'employee',
  VIEWER: 'viewer'
} as const

// Types d'utilisateur
export const USER_TYPES = {
  INTERNAL: 'internal',
  EXTERNAL: 'external'
} as const

// Permissions par rôle (exemple)
export const ROLE_PERMISSIONS = {
  [ROLES.SUPER_ADMIN]: [
    // Toutes les permissions - Super Admin a accès à tout
    ...Object.values(PERMISSIONS).flatMap(module => Object.values(module))
  ],
  [ROLES.ADMIN]: [
    // Gestion des utilisateurs
    PERMISSIONS.USER.READ,
    PERMISSIONS.USER.CREATE,
    PERMISSIONS.USER.UPDATE,
    PERMISSIONS.USER.DELETE,
    PERMISSIONS.USER.MANAGE_ROLES,
    
    // Gestion des employés
    PERMISSIONS.EMPLOYEE.READ,
    PERMISSIONS.EMPLOYEE.CREATE,
    PERMISSIONS.EMPLOYEE.UPDATE,
    PERMISSIONS.EMPLOYEE.DELETE,
    PERMISSIONS.EMPLOYEE.MANAGE_DOCUMENTS,
    PERMISSIONS.EMPLOYEE.MANAGE_CONTRACTS,
    
    // Gestion de la paie
    PERMISSIONS.PAYROLL.READ,
    PERMISSIONS.PAYROLL.CREATE,
    PERMISSIONS.PAYROLL.UPDATE,
    PERMISSIONS.PAYROLL.PROCESS,
    PERMISSIONS.PAYROLL.MANAGE_SALARIES,
    PERMISSIONS.PAYROLL.MANAGE_BONUSES,
    
    // Gestion des absences
    PERMISSIONS.ABSENCE.READ,
    PERMISSIONS.ABSENCE.CREATE,
    PERMISSIONS.ABSENCE.UPDATE,
    PERMISSIONS.ABSENCE.APPROVE,
    PERMISSIONS.ABSENCE.MANAGE_TYPES,
    
    // Gestion de la présence
    PERMISSIONS.ATTENDANCE.READ,
    PERMISSIONS.ATTENDANCE.UPDATE,
    PERMISSIONS.ATTENDANCE.MANAGE_SCHEDULES,
    
    // Gestion des rémunérations
    PERMISSIONS.REMUNERATION.READ,
    PERMISSIONS.REMUNERATION.MANAGE_SALARIES,
    
    // Gestion des notes de frais
    PERMISSIONS.EXPENSE.READ,
    PERMISSIONS.EXPENSE.APPROVE,
    
    // Gestion des syndicats
    PERMISSIONS.UNION.READ,
    PERMISSIONS.UNION.UPDATE,
    PERMISSIONS.UNION.MANAGE_MEMBERS,
    
    // Gestion des équipements
    PERMISSIONS.EQUIPMENT.READ,
    PERMISSIONS.EQUIPMENT.CREATE,
    PERMISSIONS.EQUIPMENT.UPDATE,
    PERMISSIONS.EQUIPMENT.DELETE,
    PERMISSIONS.EQUIPMENT.ASSIGN,
    
    // Gestion des documents
    PERMISSIONS.DOCUMENT.READ,
    PERMISSIONS.DOCUMENT.CREATE,
    PERMISSIONS.DOCUMENT.UPDATE,
    PERMISSIONS.DOCUMENT.DELETE,
    PERMISSIONS.DOCUMENT_TYPE.READ,
    PERMISSIONS.DOCUMENT_TYPE.CREATE,
    PERMISSIONS.DOCUMENT_TYPE.UPDATE,
    PERMISSIONS.DOCUMENT_TEMPLATE.READ,
    PERMISSIONS.DOCUMENT_TEMPLATE.CREATE,
    PERMISSIONS.DOCUMENT_TEMPLATE.UPDATE,
    
    // Rapports et analytics
    PERMISSIONS.REPORTS.READ,
    PERMISSIONS.REPORTS.CREATE_CUSTOM,
    PERMISSIONS.ANALYTICS.VIEW,
    
    // Configuration
    PERMISSIONS.SETTINGS.READ,
    PERMISSIONS.SETTINGS.UPDATE,
    PERMISSIONS.SETTINGS.MANAGE_LOCAL,
    
    // Tableau de bord
    PERMISSIONS.DASHBOARD.READ,
    PERMISSIONS.DASHBOARD.CONFIGURE,
    
    // Notifications
    PERMISSIONS.NOTIFICATION.READ,
    PERMISSIONS.NOTIFICATION.SEND,
    
    // Audit
    PERMISSIONS.AUDIT.READ,
    
    // Gestion des départements et postes
    PERMISSIONS.DEPARTMENT.READ,
    PERMISSIONS.DEPARTMENT.CREATE,
    PERMISSIONS.DEPARTMENT.UPDATE,
    PERMISSIONS.POSITION.READ,
    PERMISSIONS.POSITION.CREATE,
    PERMISSIONS.POSITION.UPDATE,
    PERMISSIONS.EMPLOYMENT_TYPE.READ,
    PERMISSIONS.EMPLOYMENT_TYPE.CREATE,
    PERMISSIONS.EMPLOYMENT_TYPE.UPDATE,
    PERMISSIONS.COMPETENCE_TYPE.READ,
    PERMISSIONS.COMPETENCE_TYPE.CREATE,
    PERMISSIONS.COMPETENCE_TYPE.UPDATE,
    PERMISSIONS.DEPARTURE_REASON.READ,
    PERMISSIONS.DEPARTURE_REASON.CREATE,
    PERMISSIONS.DEPARTURE_REASON.UPDATE
  ],
  [ROLES.MANAGER]: [
    // Gestion des employés (lecture et modification limitée)
    PERMISSIONS.EMPLOYEE.READ,
    PERMISSIONS.EMPLOYEE.UPDATE,
    
    // Gestion des absences
    PERMISSIONS.ABSENCE.READ,
    PERMISSIONS.ABSENCE.APPROVE,
    
    // Gestion de la présence
    PERMISSIONS.ATTENDANCE.READ,
    PERMISSIONS.ATTENDANCE.UPDATE,
    
    // Gestion des notes de frais
    PERMISSIONS.EXPENSE.READ,
    PERMISSIONS.EXPENSE.APPROVE,
    
    // Gestion des syndicats
    PERMISSIONS.UNION.READ,
    
    // Gestion des équipements
    PERMISSIONS.EQUIPMENT.READ,
    PERMISSIONS.EQUIPMENT.ASSIGN,
    
    // Gestion des documents
    PERMISSIONS.DOCUMENT.READ,
    PERMISSIONS.DOCUMENT.CREATE,
    PERMISSIONS.DOCUMENT.UPDATE,
    
    // Rapports
    PERMISSIONS.REPORTS.READ,
    PERMISSIONS.ANALYTICS.VIEW,
    
    // Tableau de bord
    PERMISSIONS.DASHBOARD.READ,
    
    // Notifications
    PERMISSIONS.NOTIFICATION.READ,
    
    // Tâches et projets
    PERMISSIONS.TASK.READ,
    PERMISSIONS.TASK.CREATE,
    PERMISSIONS.TASK.ASSIGN,
    PERMISSIONS.PROJECT.READ,
    PERMISSIONS.PROJECT.UPDATE,
    
    // Calendrier
    PERMISSIONS.CALENDAR.READ,
    PERMISSIONS.CALENDAR.UPDATE,
    PERMISSIONS.CALENDAR.MANAGE_EVENTS,
    
    // Planning
    PERMISSIONS.PLANNING.READ,
    PERMISSIONS.PLANNING.UPDATE,
    
    // Congés
    PERMISSIONS.LEAVE.READ,
    PERMISSIONS.LEAVE.APPROVE
  ],
  [ROLES.EMPLOYEE]: [
    // Lecture de ses propres données
    PERMISSIONS.EMPLOYEE.READ,
    
    // Gestion des absences
    PERMISSIONS.ABSENCE.READ,
    PERMISSIONS.ABSENCE.CREATE,
    PERMISSIONS.ABSENCE.SUBMIT,
    
    // Gestion des notes de frais
    PERMISSIONS.EXPENSE.READ,
    PERMISSIONS.EXPENSE.CREATE,
    PERMISSIONS.EXPENSE.SUBMIT,
    
    // Gestion des documents
    PERMISSIONS.DOCUMENT.READ,
    PERMISSIONS.DOCUMENT.UPLOAD,
    PERMISSIONS.DOCUMENT.DOWNLOAD,
    
    // Fichiers
    PERMISSIONS.FILE.UPLOAD,
    PERMISSIONS.FILE.DOWNLOAD,
    
    // Formulaires
    PERMISSIONS.FORM.READ,
    PERMISSIONS.FORM.SUBMIT,
    
    // Calendrier
    PERMISSIONS.CALENDAR.READ,
    
    // Tâches
    PERMISSIONS.TASK.READ,
    PERMISSIONS.TASK.UPDATE,
    
    // Congés
    PERMISSIONS.LEAVE.READ,
    PERMISSIONS.LEAVE.CREATE,
    PERMISSIONS.LEAVE.UPDATE,
    
    // Tableau de bord
    PERMISSIONS.DASHBOARD.READ,
    
    // Notifications
    PERMISSIONS.NOTIFICATION.READ
  ],
  [ROLES.VIEWER]: [
    // Lecture seule des données principales
    PERMISSIONS.EMPLOYEE.READ,
    PERMISSIONS.ABSENCE.READ,
    PERMISSIONS.ATTENDANCE.READ,
    PERMISSIONS.DOCUMENT.READ,
    PERMISSIONS.REPORTS.READ,
    PERMISSIONS.DASHBOARD.READ,
    PERMISSIONS.NOTIFICATION.READ
  ]
} as const
